import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  updateBidsList,
  placeBid,
  findBidData
} from 'src/redux/actions/bidding';
import { sendNotification } from 'src/redux/actions/notifications';
import {
  getLocale,
  getAllRequisition,
  getAllRequisitionIds,
  getUser,
  getTimeStamp,
  getBidData
} from 'src/redux/selectors';
import { findAllStock } from 'src/redux/actions/stock';
import {
  addRequisition,
  deleteRequisition,
  findAllRequisition
} from 'src/redux/actions/requisition';
import {
  addRequest,
  findJobNumbers,
  findTechnicians
} from 'src/redux/actions/request';
import { withRouter, Link } from 'react-router-dom';

class Requisition extends Component {
  render = () => {
    const {
      Layout,
      currentLocale,
      requisition,
      user,
      findAllStock,
      stock,
      findAllRequisition,
      addRequisition,
      deleteRequisition,
      sendNotification,
      findJobNumbers,
      findTechnicians,
      addRequest,
      push,
      history
    } = this.props;
    return (
      <Layout
        currentLocale={currentLocale}
        requisition={requisition}
        user={user}
        findAllStock={findAllStock}
        stock={stock}
        findAllRequisition={findAllRequisition}
        addRequisition={addRequisition}
        deleteRequisition={deleteRequisition}
        sendNotification={sendNotification}
        findJobNumbers={findJobNumbers}
        findTechnicians={findTechnicians}
        addRequest={addRequest}
        push={push}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  currentLocale: getLocale(state) || {},
  requisition: state.requisition.allRequisition || [],
  stock: state.stock.allStock || [],
  user: getUser(state) || {}
});

const mapDispatchToProps = {
  getLocale,
  findAllRequisition,
  findAllStock,
  addRequisition,
  deleteRequisition,
  sendNotification,
  push,
  findJobNumbers,
  findTechnicians,
  addRequest
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Requisition)
);
